import styled from 'styled-components';

export const InpuTypeString = styled.input`
  background-color: transparent;
  border: 1px solid;
  border-color: #ccc;
  box-sizing: border-box;
  padding: 10px 20px;
  color: inherit;
  cursor: inherit;
  font-size: 14px;
  min-width: 0;
  width: 100%;
  line-height: 1.4285714285714286;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  margin-bottom: 8px;
`;

export const FilterHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const FilterTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const FilterTitle = styled.h4`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  min-width: fit-content;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;

  &:hover {
    color: #d32f2f;
    background-color: #f5f5f5;
    border-radius: 4px;
  }
`;

export const ConditionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ConditionDropdown = styled.select`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
  cursor: pointer;
  min-width: 150px;

  &:focus {
    outline: none;
    border-color: #0052cc;
    box-shadow: 0 0 0 2px rgba(0, 82, 204, 0.2);
  }
`;

export const FilterRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BetweenLabel = styled.div`
  text-align: center;
  font-size: 14px;
  color: #666;
  margin: 8px 0;
  font-weight: 500;
`;

export const FullWidthButton = styled.div`
  width: 100%;

  > button {
    width: 100%;
  }
`;
